const InstallAddInButton = ({ url }) => {
    return (
        <a
            href={url}
            title='Install AI Perfect Assistant Add-In'
            className={`
inline-flex
items-center
px-4
py-4
mt-4
text-lg
font-bold
transition-all
duration-200
bg-transparent
border border-transparent
sm:mt-0
font-pj
justify-center
rounded-xl
focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300
hover:bg-gray-200
focus:bg-gray-200
`}
            role='button'>
            <svg
                className='w-5 h-5 mr-2'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'>
                <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2.5'
                    d='M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4'></path>
            </svg>
            Install Add-In
        </a>
    );
};

export default InstallAddInButton;
